module.exports = __webpack_public_path__ + "img/bad.be5030ca.webp";